const ButtonTypes = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
  TERTIARY: 'TERTIARY',
  ICON: 'ICON',
};

export { ButtonTypes as default };
